module.exports = __webpack_public_path__ + "img/favicons/ape/apple-touch-icon.png";